/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.ThemeRpc
 */

export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const BooleanFieldValueDiscriminant = 'boolean';
export const BooleanFieldValueDiscriminantKey = '@type';
export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const DoubleFieldValueDiscriminant = 'double';
export const DoubleFieldValueDiscriminantKey = '@type';
export const FieldValueDiscriminantKey = '@type';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const FloatFieldValueDiscriminant = 'float';
export const FloatFieldValueDiscriminantKey = '@type';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const IntFieldValueDiscriminant = 'integer';
export const IntFieldValueDiscriminantKey = '@type';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const ListFieldValueDiscriminant = 'list';
export const ListFieldValueDiscriminantKey = '@type';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const LongFieldValueDiscriminant = 'long';
export const LongFieldValueDiscriminantKey = '@type';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const MapFieldValueDiscriminant = 'map';
export const MapFieldValueDiscriminantKey = '@type';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const NullFieldValueDiscriminant = 'null';
export const NullFieldValueDiscriminantKey = '@type';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const StringFieldValueDiscriminant = 'string';
export const StringFieldValueDiscriminantKey = '@type';
export const BrightnessOffsetModifierTypename = 'com.hubspot.content.model.customwidgets.inherited.BrightnessOffsetModifier';
export const BrightnessOffsetModifierDiscriminant = 'BRIGHTNESS_OFFSET';
export const BrightnessOffsetModifierDiscriminantKey = 'modifier_type';
export const ModifierDiscriminantKey = 'modifier_type';
export const ShadeModifierTypename = 'com.hubspot.content.model.customwidgets.inherited.ShadeModifier';
export const ShadeModifierDiscriminant = 'SHADE';
export const ShadeModifierDiscriminantKey = 'modifier_type';
export const ShadeOffsetModifierTypename = 'com.hubspot.content.model.customwidgets.inherited.ShadeOffsetModifier';
export const ShadeOffsetModifierDiscriminant = 'SHADE_OFFSET';
export const ShadeOffsetModifierDiscriminantKey = 'modifier_type';
export const BadRequestErrorTypename = 'com.hubspot.global.styles.models.rpc.BadRequestError';
export const BadRequestErrorDiscriminant = 'BadRequestError';
export const BadRequestErrorDiscriminantKey = '@type';
export const GlobalStylesErrorDiscriminantKey = '@type';
export const NotFoundErrorTypename = 'com.hubspot.global.styles.models.rpc.NotFoundError';
export const NotFoundErrorDiscriminant = 'NotFoundError';
export const NotFoundErrorDiscriminantKey = '@type';
export const ValidationErrorTypename = 'com.hubspot.global.styles.models.rpc.ValidationError';
export const ValidationErrorDiscriminant = 'ValidationError';
export const ValidationErrorDiscriminantKey = '@type';
export const getByIdRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.ThemeRpc',
  rpcName: 'getById',
  auth: 'app',
  fingerprint: 'nt62_NUg-IA-xjKQ4TRubM9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getActiveThemeRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.ThemeRpc',
  rpcName: 'getActiveTheme',
  auth: 'app',
  fingerprint: 'tD-QeDUsJEg-xjKQ4TRubM9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBufferedActiveThemeRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.ThemeRpc',
  rpcName: 'getBufferedActiveTheme',
  auth: 'app',
  fingerprint: 'tD-QeDUsJEg-xjKQ4TRubM9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listCustomThemesRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.ThemeRpc',
  rpcName: 'listCustomThemes',
  auth: 'app',
  fingerprint: 'aELRtzHBdUFVlfrVGZgNp89ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listDefaultThemesRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.ThemeRpc',
  rpcName: 'listDefaultThemes',
  auth: 'app',
  fingerprint: '9uI-XCBiT-n8zrPWQGEEPs9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.ThemeRpc',
  rpcName: 'create',
  auth: 'app',
  fingerprint: 'U2tVL7SLogM-xjKQ4TRubM9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.ThemeRpc',
  rpcName: 'update',
  auth: 'app',
  fingerprint: 'If1dXSxsEwQ-xjKQ4TRubM9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const archiveRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.ThemeRpc',
  rpcName: 'archive',
  auth: 'app',
  fingerprint: 'cX_3I9BKR6AQxpbF2-PL0c9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createActiveThemeRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.ThemeRpc',
  rpcName: 'createActiveTheme',
  auth: 'app',
  fingerprint: 'x1uT0p3JpUOwINooNtFC5M9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateActiveThemeRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.ThemeRpc',
  rpcName: 'updateActiveTheme',
  auth: 'app',
  fingerprint: '9qKnesqq175zawK3yiH8Gc9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const upsertActiveThemeBufferRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.ThemeRpc',
  rpcName: 'upsertActiveThemeBuffer',
  auth: 'app',
  fingerprint: 'nROO91-HWSoCdxgSxP_HBM9ozGD9Wroz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};